const state = {
  appName:
    process.env.NODE_ENV === "production"
      ? ""
      : process.env.NODE_ENV === "development"
      ? "Dev"
      : process.env.NODE_ENV === "staging"
      ? "TEST"
      : "(?)",
  apiBaseUrl: process.env.VUE_APP_API_ENDPOINT,
  socketIoURL: process.env.VUE_APP_SOCKET_IO_URL,
  defaultLang: process.env.VUE_APP_LANG || "es",
  defaultLocale: process.env.VUE_APP_LOCALE || "es-AR",
  party: process.env.VUE_APP_PARTY || "CONTRATADOS"
};

export default { state };
